import { useEffect, useState } from "react";

import { useApiClient } from "../../api-client";
import { CountryISOCode, restoreCompany } from "./restoreCompany";
import { useEmployment } from "./useEmployment";

export enum ContractType {
  COBEE = "cobee",
  PLUXEE = "pluxee",
}

export enum Source {
  COBEE = "cobee",
  COBEE_FREE_TRIAL = "cobee-free-trial",
  PLUXEE = "pluxee",
}

type Company = {
  name: string;
  country: CountryISOCode;
  source?: Source;
  contractType?: ContractType;
};

const useCompany = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [company, setCompany] = useState<Company | null>(null);
  const { get } = useApiClient();
  const { companyId } = useEmployment();

  const getCompany = async () => {
    try {
      const { data } = await get(`/v1/employee/company/${companyId}`);
      if (data) {
        const restoredCompanyData = restoreCompany(data);
        setCompany(restoredCompanyData);
      }
    } catch (error) {
      throw new Error(error as unknown as string);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!companyId) return;
    getCompany();
  }, [companyId]);

  return {
    company,
    isLoading,
  };
};

export { type Company, useCompany };
